import React from 'react'
import { Main } from './components'

const Orders = () => <Main />

export default Orders
